import { IS_MY_TEAM } from 'reactApp/appHelpers/configHelpers';

export type VkTeamBridge = typeof import('@instant-messengers/vk-teams-bridge');

export const vkTeamBridge: VkTeamBridge = import('@instant-messengers/vk-teams-bridge');

export const notifyVKTeamsThatAppReady = async (isReady: boolean) => {
    if (!IS_MY_TEAM) {
        return;
    }

    const bridge = await vkTeamBridge;

    bridge.send('LoadingCompleted', { ok: isReady }).catch((error) => console.error(error));
};
